module.exports = __webpack_public_path__ + "media/stem/sc-center-821ae5d5.svg";